import { z } from 'zod'

export const ZGenerateUploadUrl = z.object({
  fileName: z.string(),
  fileSize: z.number().max(50 * 1024 * 1024),
  prefix: z.string().optional(), // (네이밍 선택사항) 프로필: profile, 여권: registid, 채팅: chat, 방: room
})

export const ZGenerateUploadUrlResponse = z.object({
  presignedUrl: z.string(),
  objectKey: z.string(),
  contentType: z.string(),
})

export type TGenerateUploadUrl = z.infer<typeof ZGenerateUploadUrl>
export type TGenerateUploadUrlResponse = z.infer<
  typeof ZGenerateUploadUrlResponse
>
